import MarkdownIt from 'markdown-it';

export class Mark {
   /**
    * Instance Singleton
    */
   public static instance: Mark;

   /**
    * The Markdown parser
    * @private
    */
   private parser: MarkdownIt;

   constructor() {
      this.parser = new MarkdownIt();
   }

   /**
    * Returns an instance of this class
    * @constructor
    */
   public static get Down(): Mark {
      if (!this.instance) {
         this.instance = new Mark();
      }
      return this.instance;
   }

   /**
    * Renders the specified markdown string
    * @param input the input to render
    */
   public render(input: string): string {
      return this.parser.renderInline(input);
   }
}
